import { Sparkles } from 'lucide-react';
import { useBeta } from '../../context/BetaContext';

/**
 * Bandeau « Version bêta », purement informatif.
 * Ne rend rien si le mode Bêta est désactivé dans l'administration (interrupteur
 * BETA_ENABLED). Le Gratuit ouvre tous les modules avec des limites par module,
 * bêta ou non : le bandeau ne promet donc plus de période gratuite ni de date.
 *
 * La configuration vient de BetaContext : elle est lue une seule fois pour
 * toute l'application, ce qui évite que le bandeau, le badge et les routes
 * se désynchronisent pendant le chargement.
 */
const BetaBanner = () => {
    const { betaConfig: config, betaEnabled, betaLoading } = useBeta();

    if (betaLoading || !betaEnabled || !config) {
        return null;
    }

    return (
        <div
            role="status"
            className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-cabaza-purple to-cabaza-pink"
        >
            <span className="px-2 py-0.5 text-xs font-bold uppercase bg-white/25 rounded-full">
                Bêta
            </span>
            <Sparkles className="w-4 h-4 flex-shrink-0" />
            <span>{config.message}</span>
        </div>
    );
};

export default BetaBanner;
